<template>
  <div class="container-fluid">
    <h2 class="title text-center">綠能公車亭智慧照明應用 - 顯示詳細資料</h2>
    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <table class="data-table flex-fill">
          <thead>
            <tr>
            <th>人體感測</th>
            <th>數值</th>
            <th>智慧控制</th>
            <th>數值</th>
            <th>儲能裝置</th>
            <th>數值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
            <td style="color: #4FC3F7">人體存在</td>
            <td>{{ Human_Detected }}</td>
            <td style="color: #4FC3F7">亮度</td>
            <td>{{ Lightness }}</td>
            <td style="color: #4FC3F7">SOC</td>
            <td>{{ SOC }}</td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">工作模式</td>
            <td>{{ Work_Mode }}</td>
            <td style="color: #4FC3F7">光感亮度</td>
            <td>{{ SensorLightness }}</td>
            <td style="color: #4FC3F7">SOH</td>
            <td>{{ SOH }}</td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">延時秒數</td>
            <td>{{ Delay_Sec }}</td>
            <td style="color: #4FC3F7">環境溫度</td>
            <td>{{ Temperature }}</td>
            <td style="color: #4FC3F7">電池電壓</td>
            <td>{{ Total_Voltage }}</td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">光照度等級</td>
            <td>{{ Illuminance_level }}</td>
            <td style="color: #4FC3F7">風扇開關</td>
            <td>{{ Fan }}</td>
            <td style="color: #4FC3F7">電池電流</td>
            <td>{{ Total_Current }}</td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">靈敏度</td>
            <td>{{ Sensitivity }}</td>
            <td style="color: #4FC3F7">告示燈</td>
            <td>{{ LightBox }}</td>
            <td></td>
            <td></td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">指示燈開關</td>
            <td>{{ Switch }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">主動上傳</td>
            <td>{{ Active_Upload }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">開關次數</td>
            <td>{{ Switch_Count }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">強制開啟</td>
            <td>{{ Force_On }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            </tr>

            <tr>
            <td style="color: #4FC3F7">運動幅度</td>
            <td>{{ Movement_Range }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 d-flex justify-content-center text-white mt-2">
        感測器更新時間: {{SensroUpdateTime}}
      </div>
      <div class="col-12 d-flex justify-content-center text-white">
        儲能更新時間: {{DeviceUpdateTime}}
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config/global'
import io from 'socket.io-client'

export default {
  data() {
    return {
      socket: null,
      Human_Detected: 0,
      Work_Mode: 0,
      Delay_Sec: 0,
      Illuminance_level: 0,
      Sensitivity: 0,
      Switch: 0,
      Active_Upload: 0,
      Switch_Count: 0,
      Force_On: 0,
      Movement_Range: 0,
      Lightness: 0,
      SensorLightness: 0,
      Temperature: 0,
      LightBox: 0,
      Fan: 0,
      SOH: 0,
      SOC: 0,
      Total_Voltage: 0,
      Total_Current: 0,
      SensroUpdateTime: '未知',
      DeviceUpdateTime: '未知',
      refresh_interval: 60000,//60sec
      refresh_time: null,
    };
  },
  mounted(){
    let app = this;
    
    this.socket = io(config.socket_entry, {
      upgrade: true,
      rememberUpgrade: true,
      forceNode: true,
    });

    this.socket.on('connect', () => {
      console.log('Socket 已連線');
      //this.ReadPower();
    });

    this.socket.on('disconnect', () => {
      console.log('Socket 已斷線');
    });

    this.socket.on('update', (data) => {
      console.info('update:', data);
      if(data.success){
        this.Refresh(data.device);
      }
    });

    this.SensorRequest();
  },
  beforeDestroy(){
    if(this.refresh_time) {
      clearTimeout(this.refresh_time);
    }
    if (this.socket) {
      this.socket.disconnect(); // 斷開連線
      this.socket = null; // 清空引用，確保 GC 回收
      console.log('Socket 已釋放');
    }
  },
  methods: {
    Refresh(device){
      if(device){
        let firstSensor = Object.values(device.Sensors)[0];
        if(firstSensor) {
          this.Human_Detected = firstSensor.Human_Detected;
          this.Work_Mode = firstSensor.Work_Mode;
          this.Delay_Sec = firstSensor.Delay_Sec;
          this.Illuminance_level = firstSensor.Illuminance_level;
          this.Sensitivity = firstSensor.Sensitivity;
          this.Switch = firstSensor.Switch;
          this.Active_Upload = firstSensor.Active_Upload;
          this.Switch_Count = firstSensor.Switch_Count;
          this.Force_On = firstSensor.Force_On;
          this.Movement_Range = firstSensor.Movement_Range;
          this.Lightness = firstSensor.Lightness;
          this.SensorLightness = firstSensor.SensorLightness;
          this.Temperature = firstSensor.Temperature;
          this.Fan = firstSensor.Fan;
          this.LightBox = firstSensor.LightBox;
          this.SensroUpdateTime = firstSensor.UpdateTime ? firstSensor.UpdateTime : '未知';
          //console.log('firstSensor.UpdateTime:' + firstSensor.UpdateTime + ', SensroUpdateTime:' + this.SensroUpdateTime);
        }

        this.SOH = device.Pack.SOH;
        this.SOC = device.Pack.SOC;
        this.Total_Voltage = device.Pack.Total_Voltage;
        this.Total_Current = (device.Pack.Total_Current + device.Pack2.Total_Current).toFixed(1);
        this.DeviceUpdateTime = device.UpdateTime ? device.UpdateTime : '未知';
        //console.log('device.UpdateTime:' + device.UpdateTime + ', DeviceUpdateTime:' + this.DeviceUpdateTime);
      }
    },
    SensorRequest(){
      this.$jsonp(`${config.api_root}/SensorRequest`, {
        sn: encodeURIComponent(config.encrypt('ECO04-0001', config.ffkey, config.ffiv)),
        user_id: encodeURIComponent(3),
      }, 5000).then((result) => {
        //console.info('result:', result);
        if(result.success){
        }
      });
    },
    ReadPower() { //No used now
      this.$jsonp(`${config.api_root}/ReadPower`, {
        sn: encodeURIComponent(config.encrypt('ECO04-0001', config.ffkey, config.ffiv)),
        user_id: encodeURIComponent(3),
      }, 5000).then((result) => {
        //console.info('result:', result);
        if(result.success){
          this.Refresh(result.device);
        }
      });
    },
    RefreshTimer(){ //No used now
      //let app = this;
      if(this.refresh_time) {
        clearTimeout(this.refresh_time);
        this.refresh_time = null;
      }

      this.$jsonp(`${config.api_root}/ReadPower`, {
        sn: encodeURIComponent(config.encrypt('ECO04-0001', config.ffkey, config.ffiv)),
        user_id: encodeURIComponent(3),
      }, 5000).then((result) => {
        //console.info('result:', result);
        if(result.success){
          this.Refresh(result.device);
        }
      });

      this.refresh_time = setTimeout(() => {
        this.RefreshTimer();
      }, this.refresh_interval);
    }
  }
};
</script>
  
<style>
/* 整個頁面黑色背景 */
.container2 {
  text-align: center;
  padding: 20px;
  background-color: #000; /* 黑色背景 */
  color: white; /* 文字變白 */
  height: 80vh;
  /*min-height: 70vh;  讓頁面填滿整個畫面 */
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;  /* 讓 `.container` 佔滿父層 */
  max-width: 100vw;
  height: 80vh;
  background-color: black;
  color: white; /* 文字變白 */
  position: relative;
}

/* 標題樣式 */
.title {
  font-size: 28px; /* 放大標題 */
  font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}

.subtitle {
  font-size: 18px; /* 放大副標題 */
  color: gray;
  margin-bottom: 20px;
}

/* 表格樣式 */
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #222; /* 深灰色表格背景 */
  font-size: 22px; /* 整體字體變大 */
  border: 2px solid red;
}

.data-table th, .data-table td {
  border: 2px solid #555; /* 灰色邊框 */
  padding: 15px; /* 增加間距 */
  text-align: center;
  color: white; /* 白色文字 */
}

.data-table th {
  background-color: #444; /* 深灰色標題 */
  color: #00ff00; /* 綠色標題字體 */
  font-size: 24px; /* 表頭字體再大一點 */
}
</style>
  